import type { EmbarcacaoVelocidadeConsumoField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const VELOCIDADE_CONSUMO_ID = "velocidade-consumo";
export const VELOCIDADE_CONSUMO_TITLE = "Velocidade e Consumo";
export const VELOCIDADE_CONSUMO_TEST_ID = "embarcacao-velocidade-consumo";
export const VELOCIDADE_CONSUMO_LOADING_MESSAGE =
  "Carregando a Velocidade e Consumo da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const VELOCIDADE_CONSUMO_EMPTY_STATE = {
  title: "Nenhuma informação de Velocidade e Consumo disponível",
  description:
    "Assim que houver dados de velocidade e consumo desta embarcação, eles aparecerão nesta seção.",
};

/** Os 7 campos, na ordem da HU; a unidade de medida (RN002) fica no rótulo, nunca no valor. */
export const VELOCIDADE_CONSUMO_FIELDS: DetailFieldDefinition<EmbarcacaoVelocidadeConsumoField>[] =
  [
    { key: "velMaximaBarco", label: "Vel. Máxima do Barco (nós)" },
    { key: "consumoVelMaximaBarco", label: "Consumo Vel. Máxima do Barco (m³)" },
    { key: "velServico", label: "Vel. Serviço (nós)" },
    { key: "consumoVelServico", label: "Consumo Vel. Serviço (m³)" },
    { key: "velEconomica", label: "Vel. Econômica (nós)" },
    { key: "consumoVelEconomica", label: "Consumo Vel. Econômica (m³)" },
    {
      key: "atualizacaoVelocidadeConsumo",
      label: "Data Atualização Velocidade e Consumo",
      format: formatDetailDate,
    },
  ];
